export interface IPlano {
  IdPlano: number
  Ativo: boolean
  Inclusao: string
}

// NOVAS INTERFACES PARA MULTI-RANGE
export interface IPlanoRange {
  min: number
  max: number
  valor: number
}

export interface IPlanoMultiRangeRequest {
  IdCliente: number
  TipoPlano: TipoPlano

  // PRÉ PAGO: range limitado (não infinito)
  QuantidadeMinimaPre?: number
  QuantidadeMaximaPre?: number
  ValorPre?: number
  ValorUnitarioPre?: number
  ExpiracaoPre?: Date

  RangesPosPago?: IPlanoRange[] // formato: "0,1000,0.75|1001,2000,0.65|2001,3000,1.00"

  // FEE MENSAL: primeiro fixo + outros unitários
  QuantidadeMinimaFee?: number
  QuantidadeMaximaFee?: number
  ValorFee?: number
  QuantidadeMinimaExcedente?: number
  ValorUnitarioExcedente?: number

  // POC: valor dinâmico
  QuantidadePOC?: number
  ExpiracaoPOC?: Date

  RangesFeeExcedente?: IPlanoRange[] // formato: "0,999999999,0.10" para compatibilidade
}

export enum TipoPlano {
  PrePago = 1,
  PosPago = 2,
  FeeMensal = 3,
  POC = 8
}

export interface IPlanoCompletoMultiRange {
  data: any
  IdCliente: number
  ClienteNome: string
  ClienteDocumento: string
  IdPlano: number
  TipoPlano: TipoPlano
  PlanoInclusao: Date
  IdPlanoCliente: number
  PlanoClienteAtivo: boolean
  PlanoClienteInclusao: Date
  PlanoClienteAtualizacao?: Date

  // Campos específicos por tipo (exatamente como o backend retorna)
  FeeQuantidadeMinima?: number
  FeeQuantidadeMaxima?: number
  FeeValorMensal?: number
  FeeInclusao?: Date

  RangesFeeExcedente?: IPlanoRange[]
  FeeExcedenteQuantidadeMinima?: number
  FeeExcedenteQuantidadeMaxima?: number
  FeeExcedenteValorUnitario?: number
  FeeExcedenteInclusao?: Date

  PosQuantidadeMinima?: number
  PosQuantidadeMaxima?: number
  PosValorUnitario?: number
  PosInclusao?: Date
  RangesPosPago?: IPlanoRange[]

  PreQuantidade?: number
  PreValorTotal?: number
  PreValorUnitario?: number
  PreInclusao?: Date
  PreExpiracao: Date

  POCQuantidade?: number
  POCExpiracao: Date
  POCInclusao?: Date
}
// DTOs para requisições
export interface IInserirPlanoRequest {
  IdCliente: number
  TipoPlano: TipoPlano
  QuantidadeMinimaFee?: number
  QuantidadeMaximaFee?: number
  ValorFee?: number
  QuantidadeMinimaExcedente?: number
  ValorUnitarioExcedente?: number
  QuantidadeMinimaPos?: number
  QuantidadeMaximaPos?: number
  ValorUnitarioPos?: number
  QuantidadePre?: number
  ValorPre?: number
  ValorUnitarioPre?: number
}

export interface IAtualizarPlanoRequest {
  IdCliente: number
  TipoPlano: TipoPlano
  QuantidadeMinimaFee?: number
  QuantidadeMaximaFee?: number
  ValorFee?: number
  QuantidadeMinimaExcedente?: number
  ValorUnitarioExcedente?: number
  QuantidadeMinimaPos?: number
  QuantidadeMaximaPos?: number
  ValorUnitarioPos?: number
  QuantidadePre?: number
  ValorPre?: number
  ValorUnitarioPre?: number
}

export interface IObterPlanoPorClienteRequest {
  IdCliente: number
}

export type PlanoViewMode = 'create' | 'edit' | 'view';

export interface PlanosVelesTabProps {
  IdCliente: number;
  isEditMode?: boolean;
  viewMode?: PlanoViewMode;
}

export interface PlanosVelesTabRef {
  getPlanoData: () => IPlanoMultiRangeRequest | null;
  getErrorMessage: () => string;
}

export enum TipoPlanoLabel {
  PrePago = 'Pré Pago',
  PosPago = 'Pós Pago',
  FeeMensal = 'Fee Mensal',
  POC = 'POC'
}
